export default __webpack_public_path__ + "static/media/install-app-1-android.fcf391c4.jpg";